import React from 'react'
import logo from '@/assets/fairstays-logo.png'

interface FairStaysLogoProps {
  className?: string
  size?: number
  alt?: string
}

export const FairStaysLogo: React.FC<FairStaysLogoProps> = ({ 
  className = "h-6 w-6", 
  size,
  alt = "Fair-Stays Logo" 
}) => {
  const sizeStyle = size ? { width: size, height: size } : {}
  
  return (
    <img 
      src={logo} 
      alt={alt}
      className={className}
      style={sizeStyle}
      loading="lazy"
    />
  )
}

export default FairStaysLogo